import { topic, type Topic } from "../define";

// The APIs of the reference. `file` is read by the Vite plugin; the rest
// names the pages. Topics are the `##` sections of the overview page.
export type ApiSource = {
  id: string;
  file: string;
  path: string;
  title: string;
  description: string;
  topics: readonly Topic[];
};

const TOPICS = [
  topic("Base URL"),
  topic("Authentication"),
  topic("Pagination"),
  topic("Errors"),
];

export const API_SOURCES: readonly ApiSource[] = [
  {
    id: "storefront",
    file: "apis/storefront.yaml",
    path: "/api/storefront",
    title: "Storefront API",
    description:
      "Endpoints of the Storefront API: the shop, its products, carts, checkout and the signed-in customer.",
    topics: TOPICS,
  },
  {
    id: "private",
    file: "apis/private.yaml",
    path: "/api/private",
    title: "Private API",
    description:
      "Endpoints of the Private API: server-side access to customers, subscriptions, orders and the rest of your shop.",
    topics: TOPICS,
  },
  {
    id: "orders",
    file: "apis/orders.yaml",
    path: "/api/orders",
    title: "Orders API",
    description:
      "Endpoints of the Orders API: read the orders of your shop and mark them as shipped.",
    topics: TOPICS,
  },
];
